import React from 'react';
import {observable, action, computed, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import s from '../../s';
import * as util from '../../../util';
import ModalSimple from '../../../global/modal-simple';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/scrollbar';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/zoom';
import {Keyboard, Scrollbar, Navigation, Zoom} from 'swiper/modules';
import ProductRender from '../../rendering/render';
import {r} from '../../rendering/core';
import * as emitter from '../../../global/emitter';
import AbTestStore, {ABTestKeys} from '../../../global/store/ab-test.store';

declare const window: any;
declare var __portal: IPortalSettings;

@observer
export default class SliderTH extends React.Component {
    @observable zoom_id: string = '';
    @observable _slides: string[] = [];
    @observable _slideViewCount: number = 6;
    @observable hasInit: boolean = false;
    @observable debug: boolean = true;

    constructor(props) {
        super(props);
        this.loadSwiper = this.loadSwiper.bind(this);
        this.loadSwiperZoom = this.loadSwiperZoom.bind(this);
        this.toggleZoom = this.toggleZoom.bind(this);
        this.init = this.init.bind(this);
        makeObservable(this);

        this.getSlidesPerView();

        document.addEventListener('modal-closed', function (e: any) {
            if (e.detail === 'modal-prod-swiper-th') {
                s.ui.zoom_thumbnails = false;
            }
        });
    }

    abForceUpdate = async () => this.forceUpdate();

    componentDidMount() {
        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'ab', this.abForceUpdate);
        this.init();
    }

    @action
    init = () => {
        if (this.debug) console.log('1 this.hasInit', this.hasInit);
        if (!s || !s.prod) return;

        if (this.hasInit) {
            return;
        }

        this._slides = [];
        if (!s.prod.th1Disabled) this._slides.push(s.prod.th1);
        if (!s.prod.th2Disabled) this._slides.push(s.prod.th2);
        if (!s.prod.th3Disabled) this._slides.push(s.prod.th3);
        if (!s.prod.th4Disabled) this._slides.push(s.prod.th4);
        if (!s.prod.th5Disabled) this._slides.push(s.prod.th5);
        if (!s.prod.th6Disabled) this._slides.push(s.prod.th6);
        if (!s.prod.th7Disabled) this._slides.push(s.prod.th7);
        if (!s.prod.th8Disabled) this._slides.push(s.prod.th8);
        if (!s.prod.th9Disabled) this._slides.push(s.prod.th9);
        if (!s.prod.th10Disabled) this._slides.push(s.prod.th10);

        this.hasInit = true;
        if (this.debug) console.log('2 this.hasInit', this.hasInit);

        this.getSlidesPerView();
        this.forceUpdate();

        if (this.debug) console.log('this._slides.length', this._slides.length);
    };

    @computed get show_slider(): boolean {
        if (!s.ready || !s.prod) {
            return false;
        }

        if (!this._slides || this._slides.length < 1) {
            this.init();
            if (this.debug) console.log('show_slider 1');
            if (!this._slides || this._slides.length < 1) {
                return false;
            }
            if (this.debug) console.log('show_slider 2');
            return true;
        }
        return true;
    }

    @computed get do_loop(): boolean {
        if (!s.ready) {
            return true;
        }

        if (this._slides.length <= 6) {
            return false;
        }

        return s.prod.CustomizationMethod >= 2;
    }

    @action getSlidesPerView(value: number = 0) {
        if (window.innerWidth < 340) {
            this._slideViewCount = 3;
        } else if (window.innerWidth < 400) {
            this._slideViewCount = 3 + value;
        } else if (window.innerWidth < 510) {
            this._slideViewCount = 4 + value;
        } else if (window.innerWidth < 580) {
            this._slideViewCount = 5 + value;
        } else {
            this._slideViewCount = 6 + value;
        }

        if (this.debug) console.log('this._slideViewCount', this._slideViewCount);
    }

    @action
    loadSwiper = async (swiper: any) => {
        util.ariaPulse();
    };

    @action
    loadSwiperZoom = async (swiper: any) => {
        if (!util.isNullOrWhiteSpace(this.zoom_id)) {
            var ele = document.getElementById(this.zoom_id);
            var index = parseInt(ele?.attributes['data-swiper-slide-index'].value, 10);
            swiper.slideToLoop(index);

            setTimeout(function () {
                swiper.slideToLoop(index);
            }, 250);
            setTimeout(function () {
                swiper.slideToLoop(index);
            }, 1250);
        }
        this.zoom_id = '';
        util.ariaPulse();
    };

    @action
    toggleZoom = async (e: any) => {
        this.zoom_id = e;
        s.pcs.css_zoom = r.render(s.prod.orig_pcs, util.RenderType.Zoom);
        s.ui.zoom_thumbnails = true;
        util.modal('modal-prod-swiper-th');
    };

    render() {
        if (!s.ready) {
            if (this.debug) console.log('s not ready');
            return;
        }
        if (!this.show_slider) {
            if (this.debug) console.log('this.show_slider', this.show_slider);
            return;
        }

        if (!this.hasInit) {
            this.init();
        }

        if (!this._slides || this._slides.length < 1) {
            if (this.debug) console.log('his._slides null or empty');
            return;
        }

        return (
            <div>
                <Swiper
                    id="prod-swiper-th"
                    onInit={this.loadSwiper}
                    slidesPerView={this._slideViewCount}
                    centeredSlidesBounds={!this.do_loop}
                    centeredSlides={!this.do_loop}
                    centerInsufficientSlides={!this.do_loop}
                    grabCursor={this.do_loop}
                    zoom={false}
                    keyboard={{
                        enabled: this.do_loop,
                    }}
                    scrollbar={false}
                    navigation={this.do_loop}
                    height={75}
                    loop={this.do_loop}
                    pagination={false}
                    modules={[Keyboard, Scrollbar, Navigation, Zoom]}
                    aria-roledescription="carousel"
                    role="region"
                    aria-label="Product images"
                >
                    {s.prod.CustomizationMethod === 2 &&
                        this._slides.map((m, i) => (
                            <SwiperSlide
                                key={i}
                                onClick={() => this.toggleZoom(`slide-prod-real-${i}`)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        this.toggleZoom(`slide-prod-real-${i}`);
                                    }
                                }}
                                aria-label="Open larger image of this real life image"
                                tabIndex={0}
                                role="button"
                            >
                                <picture>
                                    <source
                                        type="image/webp"
                                        srcSet={`https://${s.Portal.CDNDomain}${this._slides[i]}`}
                                    />
                                    <img
                                        alt="Real Life Image #1"
                                        src={`https://${s.Portal.CDNDomain}${this._slides[i]}`}
                                        height={75}
                                        width="75"
                                    />
                                </picture>
                            </SwiperSlide>
                        ))}
                </Swiper>
                {s.ui.zoom_thumbnails && (
                    <ModalSimple
                        id="modal-prod-swiper-th"
                        title="Product Zoom"
                        open={true}
                        maxWidth={'90%'}
                        close={() => (s.ui.zoom_thumbnails = false)}
                    >
                        <Swiper
                            id="prod-swiper-th-zoom"
                            onInit={this.loadSwiperZoom}
                            slidesPerView={1}
                            centeredSlides={true}
                            grabCursor={true}
                            zoom={true}
                            keyboard={{enabled: true}}
                            loop={true}
                            scrollbar={true}
                            navigation={true}
                            pagination={false}
                            modules={[Keyboard, Scrollbar, Navigation, Zoom]}
                            slidesPerGroupAuto={true}
                            aria-roledescription="carousel"
                            role="region"
                            aria-label="Product images"
                        >
                            {this._slides.map((m, i) => (
                                <SwiperSlide
                                    key={i}
                                    id={`slide-prod-real-${i}`}
                                >
                                    <picture className="swiper-zoom-container">
                                        <source
                                            type="image/webp"
                                            srcSet={`https://${s.Portal.CDNDomain}${this._slides[i]}`}
                                        />
                                        <img
                                            src={`https://${s.Portal.CDNDomain}${this._slides[i]}`}
                                            alt="Real Image #1"
                                            style={{
                                                maxWidth: window.innerWidth * 0.8,
                                                maxHeight: window.innerHeight * 0.8,
                                            }}
                                            onClick={this.toggleZoom}
                                        />
                                    </picture>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </ModalSimple>
                )}
            </div>
        );
    }
}
